import api from "features/api";

export const apiWithReportCache = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Every cached Strategy Report recomputes on its next request. */
    resetStrategyReportCache: builder.mutation<void, void>({
      query: () => ({
        url: `/trading/new_report/bucket/reset_cache/`,
        method: "POST",
      }),
    }),
  }),
});

export const { useResetStrategyReportCacheMutation } = apiWithReportCache;
